import React from "react";
import AuditStatusBadge from "./AuditStatusBadge";

/**
 * The audit cell for release/PV list rows.
 *
 * "Not Audited" is the default for every row, so printing it everywhere would be
 * noise — the lists only show a badge once the release has entered the audit
 * track.
 */
const AuditBadgeFor = ({ approvalNo, summaries, showNotAudited = false }) => {
  const entry = approvalNo ? summaries?.[approvalNo] : null;

  if (!entry) {
    return <span className="text-muted">—</span>;
  }

  if (!showNotAudited && (!entry.audit_status || entry.audit_status === "Not Audited")) {
    return <span className="text-muted">—</span>;
  }

  return <AuditStatusBadge status={entry.audit_status} />;
};

export default AuditBadgeFor;
